export function withoutInnerItems<T>(arr: Array<T>, start: number, deleteCount: number): Array<T> {
	const result: Array<T> = [...arr];
	result.splice(start, deleteCount);
	return result;
}